import { __assign } from "tslib";
// DS: i1.1
import React from 'react';
import IconWrap from '../IconWrap';
var DeviantArtLogo = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", null,
            React.createElement("path", { d: "M14.475 2l-.352.355-1.664 3.17-.522.353H6v4.84h3.264l.29.352L6 17.862v3.525h3.525l.352-.354 1.663-3.17.523-.353H18v-4.841h-3.264l-.29-.354L18 5.525V2z" }))))); };
DeviantArtLogo.displayName = 'DeviantArtLogo';
export default DeviantArtLogo;
//# sourceMappingURL=DeviantArtLogo.js.map